import { WebsiteStylesSettingsTypeEnum } from "./types";

export const websiteStyleSettingsItemLocoKeys = {
  [WebsiteStylesSettingsTypeEnum.Typography]: 'website_styles_settings.typography.title',
  [WebsiteStylesSettingsTypeEnum.ThemesAndColors]: 'website_styles_settings.themes_and_colors.title',
  [WebsiteStylesSettingsTypeEnum.ButtonsAndLinks]: 'website_styles_settings.buttons_and_links.title',
  [WebsiteStylesSettingsTypeEnum.FormFields]: 'website_styles_settings.form_fields.title',
  [WebsiteStylesSettingsTypeEnum.Layout]: 'website_styles_settings.layout.title',
} 
